export const KEYS = {
  DEFAULT: 'DEFAULT',
  YES: 'YES',
  NO: 'NO',
};

export const FILE_TYPES = KEYS;

const LIST = Object.keys(KEYS);

export const OOS_OPTIONS = LIST.map((item) => ({
  label: `ORDER_OOS.${item}`,
  value: item === 'YES' ? '1' : item === 'NO' ? '0' : '',
}));

export default OOS_OPTIONS;
